import { jsx as a } from "react/jsx-runtime";
const o = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M8.812 2.417a1 1 0 0 1-.229 1.395A1.4 1.4 0 0 0 8 5.021a1.4 1.4 0 0 0 .583 1.167 1 1 0 1 1-1.166 1.624A3.4 3.4 0 0 1 6 5a3.4 3.4 0 0 1 1.417-2.812 1 1 0 0 1 1.395.229M12.812 2.417a1 1 0 0 1-.229 1.395A1.4 1.4 0 0 0 12 5.021a1.4 1.4 0 0 0 .583 1.167 1 1 0 0 1-1.166 1.624A3.4 3.4 0 0 1 10 5a3.4 3.4 0 0 1 1.417-2.812 1 1 0 0 1 1.395.229M2 10a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1 4 4 0 0 1 2.38.787 4 4 0 0 1-3.03 7.16A7 7 0 0 1 11 22H9a7 7 0 0 1-7-7zm15.929 5.998a2 2 0 0 0 1.11-.29A2.001 2.001 0 0 0 18 12v3q0 .505-.072.998M16 11.104a1 1 0 0 0 0 .134v1.132a7.7 7.7 0 0 0-2.5-.37c-1.582-.017-3.063.398-4.112 1.209-.608.47-1.617.806-2.876.791h-.024c-1.02.012-1.876-.206-2.488-.54V11h12z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  o as default
};
